module.exports = __webpack_public_path__ + "img/multiply14-1.e3a48199.svg";